import { useReferralReward } from '../../helpers/hooks/useReferralReward';

const HowItWorks = () => {
  const { summaryText } = useReferralReward();

  return (
    <div className='w-full flex p-[24px] pt-[24px] pb-[32px] flex-col items-start gap-[10px] rounded-[20px] bg-[rgba(236,238,243,0.7)] mt-[52px]'>
      <div className='flex flex-col items-start gap-2'>
        <span className='text-light/70 text-[18px] font-bold leading-normal tracking-[0.32px]'>
          How it works
        </span>
        <ol className='list-decimal list-inside mt-4'>
          <li className='text-light/70 text-base leading-[18px] tracking-[0.14px] mb-3'>
            Share your referral link.
          </li>
          <li className='text-light/70 text-base leading-[18px] tracking-[0.14px] mb-3'>
            Your friend signs up and successfully completes their first rent payment through
            TenantPay.
          </li>
          <li className='text-light/70 text-base leading-[18px] tracking-[0.14px] mb-3'>
            {summaryText ? `You get ${summaryText}.` : 'You get TenantPay rewards.'}
          </li>
        </ol>
      </div>
    </div>
  );
};

export default HowItWorks;
